import type { Channel, OrderStatus } from '../types'

export const channelMap: Record<Channel, string> = {
  tb: '淘宝/天猫',
  tc: '淘宝C店',
  xhs: '小红书',
  jd: '京东',
  wa: '微信A店',
  wb: '微信B店',
  dg: '银行对公',
  zfba: '支付宝个人',
  zfbb: '支付宝企业',
  wx: '微信转账',
}

// Leibal 设计系统色值（供 JS 内联样式引用）
export const leibal = {
  ink: '#313131',
  bg: '#eeeeee',
  pure: '#ffffff',
  muted: '#9a9a9a',
  line: '#dddddd',
} as const

// Leibal 风格状态标签映射
export const statusMap: Record<OrderStatus, { text: string; className: string }> = {
  material_pending: { text: '待寄材料', className: 'status-tag-pending' },
  material_shipped: { text: '材料运输', className: 'status-tag-active' },
  received: { text: '材料签收', className: 'status-tag-active' },
  processing: { text: '正在加工', className: 'status-tag-active' },
  completed: { text: '加工完成', className: 'status-tag-done' },
  ready_to_ship: { text: '待发货', className: 'status-tag-done' },
  shipped: { text: '已发货', className: 'status-tag-done' },
  exception: { text: '制作异常', className: 'status-tag-error' },
  closed: { text: '已关闭', className: 'status-tag-closed' },
}

export const addressVerifyMap: Record<'pending' | 'verified' | 'rejected' | string, string> = {
  pending: '待确认',
  verified: '已确认',
  modified: '已修改',
}

export function formatDate(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
}

export function formatDateTime(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function getStatusIndex(status: OrderStatus): number {
  const order: OrderStatus[] = [
    'material_pending',
    'material_shipped',
    'received',
    'processing',
    'completed',
    'ready_to_ship',
    'shipped',
  ]
  return order.indexOf(status)
}

export function isDeadlineUrgent(deadline: string): boolean {
  const d = new Date(deadline)
  const now = new Date()
  const diff = d.getTime() - now.getTime()
  return diff > 0 && diff < 24 * 60 * 60 * 1000
}

export function isOverdue(deadline: string): boolean {
  return new Date(deadline) < new Date()
}
